export const rpmAction = {
  setIsRPMViewLoading: (state, action) => {
    state.isRPMViewLoading = action.payload;
  },
};
